
import React from 'react';
import { DiagnosticResult } from './types';

interface UserRolesSectionProps {
  results: DiagnosticResult;
}

export const UserRolesSection: React.FC<UserRolesSectionProps> = ({ results }) => {
  return (
    <div className="bg-muted p-4 rounded-md">
      <h3 className="font-medium mb-2">User Roles</h3>
      <div className="text-sm space-y-1">
        <p>Has Admin Role: <span className={results.has_admin_role ? "text-green-500" : "text-red-500"}>
          {results.has_admin_role ? "Yes" : "No"}
        </span></p>
        <p>Roles:</p>
        {results.user_roles.length > 0 ? (
          <pre className="bg-background p-2 rounded text-xs overflow-auto max-h-24">
            {JSON.stringify(results.user_roles, null, 2)}
          </pre>
        ) : (
          <p className="text-red-500">No roles found</p>
        )}
      </div>
    </div>
  );
};
